
export default class Logger {
    constructor(){
        this.isShowLog=localStorage.getItem('showLog');
    }
    static get instance(){
        if(!this._instance){
            this._instance = new Logger();
        }
        return this._instance;
    }
    static log(){
        if(this.instance.isShowLog!=null&&this.instance.isShowLog==1){
            console.log.apply(null,arguments);
        }
    }
    static error(){
        console.error.apply(null,arguments);
    }
}


// WEBPACK FOOTER //
// ./src/utils/Logger.js